import NpsGaugeDistributionWidget from './NpsGaugeDistributionWidget';
export default NpsGaugeDistributionWidget;



// WEBPACK FOOTER //
// ./src/components/widgetTypes/components/NpsGaugeDistributionWidget/index.js